export default {
  days: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
           'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],

  common: {
    save:          'บันทึก',
    close:         'ปิด',
    cancel:        'ยกเลิก',
    back:          'กลับ',
    add:           'เพิ่ม',
    noData:        'ไม่มีข้อมูล',
    male:          'ชาย',
    female:        'หญิง',
    error:         'เกิดข้อผิดพลาด',
    studyYear:     (y) => `ปีการศึกษา ${y}`,
    studyYearShort:(y) => `ปี ${y}`,
    classNo:       (c, r) => `ชั้น ${c} ห้อง ${r}`,
    studentCount:  (n) => `นักเรียน ${n} คน`,
    personCount:   (n) => `${n} คน`,
    active:        'ปกติ',
    withdrawn:     'ออก',
    years:         'ปี',
  },

  subjectList: {
    pageTitle:        'รายวิชาของฉัน (ภาคศาสนา)',
    noTeaching:       'ไม่มีข้อมูลการสอน',
    colCode:          'รหัสวิชา ภาค 1',
    colCode2:         'รหัสวิชา ภาค 2',
    colName:          'ชื่อวิชา',
    colSchedule:      'ตารางคาบ',
    colAttend:        'เช็คชื่อ',
    colScore:         'คะแนน',
    studentListBtn:   'รายชื่อนักเรียน',
    attendBtn:        'เช็คชื่อ',
    scoreBtn:         'คะแนน',
    noStudents:       'ไม่มีรายชื่อนักเรียน',
    studentInfo:      'ข้อมูลนักเรียน',
    identity:         'ข้อมูลส่วนตัว',
    address:          'ที่อยู่',
    father:           'บิดา',
    mother:           'มารดา',
    guardian:         'ผู้ปกครอง',
    dormitory:        'หอพัก',
    studentId:        'รหัสนักเรียน',
    idCard:           'บัตรประชาชน',
    gender:           'เพศ',
    status:           'สถานะ',
    birthDate:        'วันเกิด',
    age:              'อายุ',
    fatherName:       'ชื่อบิดา',
    fatherPhone:      'เบอร์โทรบิดา',
    motherName:       'ชื่อมารดา',
    motherPhone:      'เบอร์โทรมารดา',
    guardianName:     'ชื่อผู้ปกครอง',
    guardianRelation: 'ความสัมพันธ์',
    guardianPhone:    'เบอร์โทรผู้ปกครอง',
    dormName:         'หอพัก',
    village:          'หมู่บ้าน',
    checkinDate:      'วันที่เข้าพัก',
    noDorm:           'ไม่ได้พักในหอพัก',
  },

  attendance: {
    pageTitle:    'เช็คชื่อนักเรียน',
    noSchedule:   'ไม่มีตารางสอนสำหรับวันนี้',
    colPeriod:    'คาบ',
    colTime:      'เวลา',
    colSubject:   'วิชา',
    colClass:     'ห้อง',
    colGender:    'เพศ',
    checkBtn:     'เช็คชื่อ',
  },

  checkAttendance: {
    pageTitle:          'เช็คชื่อ — ห้อง',
    breadcrumb:         'เช็คชื่อ',
    alreadyChecked:     'เช็คชื่อคาบนี้แล้ว',
    editLink:           'คลิกเพื่อแก้ไข',
    labelDate:          'วันที่:',
    labelTopic:         'หัวข้อ:',
    topicPlaceholder:   'ระบุหัวข้อการเรียนวันนี้',
    saveBtn:            'บันทึกการเช็คชื่อ',
    saveSuccess:        'บันทึกสำเร็จ',
    noStudents:         'ไม่มีรายชื่อนักเรียน',
    colId:              'รหัส',
    colName:            'ชื่อ-สกุล',
    colStatus:          'สถานะ',
    statusPresent:      'มาเรียน',
    statusLate:         'สาย',
    statusLeave:        'ลา',
    statusAbsent:       'ขาด',
    statusWithdrawn:    'ออก',
    // ย้ายไปห้องอื่นกลางปี — ถูกเช็คชื่อที่ห้องใหม่แล้ว ห้องเดิมจึงข้ามไป
    statusTransferred:  'ย้ายห้อง',
    transferredTo:      (room) => `(ย้ายไป ${room})`,
    skippedHint:        (n) => `ข้าม ${n} คนที่ออก/ย้ายห้อง — ไม่บันทึกการเช็คชื่อของห้องนี้`,
    noCheckable:        'ไม่มีนักเรียนที่ต้องเช็คชื่อในห้องนี้',
    leaveHome:          'กลับบ้าน',
    // "ครูประจำชั้น" เฉย ๆ ไม่พอ — ครูคนหนึ่งเป็นได้ทั้งครูประจำชั้นสามัญและศาสนา
    // และทั้งสองฝั่งแจ้งลงตารางเดียวกัน ครูที่เห็นป้ายต้องรู้ว่าจะไปถามใคร
    leaveByAdvisor:     'ครูประจำชั้นสามัญแจ้งลา',
    leaveByDiscipline:  'ฝ่ายปกครองแจ้งลา',
    leaveByAcademic:    'หัวหน้าวิชาการแจ้งลา',
    leaveByIslamicAdvisor: 'ครูประจำชั้นศาสนาแจ้งลา',
    leaveReturned:      'กลับเข้าโรงเรียนแล้ว',
    errorTitle:         'ข้อผิดพลาด',
    viewCard:           'การ์ด',
    viewTable:          'ตาราง',
  },

  editAttendance: {
    pageTitle:        'แก้ไขการเช็คชื่อ — ห้อง',
    breadcrumb:       'เช็คชื่อ',
    breadcrumbEdit:   (r) => `แก้ไข — ห้อง ${r}`,
    labelDate:        'วันที่:',
    labelTopic:       'หัวข้อ:',
    topicPlaceholder: 'ระบุหัวข้อการเรียน',
    saveSuccess:      'แก้ไขสำเร็จ',
    noData:           'ไม่มีข้อมูล',
    colId:            'รหัส',
    colName:          'ชื่อ-สกุล',
    colStatus:        'สถานะ',
    saveBtn:          'บันทึก',
    backBtn:          'กลับ',
    errorTitle:       'ข้อผิดพลาด',
  },

  scoreEntry: {
    pageTitle:    'บันทึกคะแนน (ภาคศาสนา)',
    unsaved:      'มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก',
    studentCount: (n) => `รายชื่อนักเรียน (${n} คน)`,
    average:      'ค่าเฉลี่ย',
    semester1:    'ภาคเรียนที่ 1',
    semester2:    'ภาคเรียนที่ 2',
    total:        'รวม',
    saveBtn:      'บันทึกคะแนน',
    saveSuccess:  'บันทึกสำเร็จ',
    saveError:    'เกิดข้อผิดพลาด',
    noStudents:   'ไม่มีรายชื่อนักเรียน',
    colId:        'รหัส',
    colArabicName:'ชื่อภาษาอาหรับ',
    colName:      'ชื่อ-สกุล',
  },

  attendanceStat: {
    pageTitle:         'สถิติการเช็คชื่อ (ภาคศาสนา)',
    selectSubject:     'รายวิชาที่สอน',
    subjectPlaceholder:'-- เลือกรายวิชา --',
    pickHint:          'เลือกรายวิชาเพื่อดูสถิติการเช็คชื่อ',
    noSessions:        'ยังไม่มีการเช็คชื่อในรายวิชานี้',
    statBtn:           'สถิติ',
    colStat:           'สถิติ',
    sessions:          'เช็คชื่อแล้ว (ครั้ง)',
    students:          'นักเรียน',
    avgRate:           'อัตราเข้าเรียน',
    rateHint:          'มาเรียน + สาย ÷ ครั้งที่ถูกเช็ค',
    colNo:             'ที่',
    colId:             'รหัส',
    colName:           'ชื่อ-สกุล',
    colRate:           'ร้อยละ',
    periodShort:       (n) => `คาบ ${n}`,
    notChecked:        'ไม่มีข้อมูลการเช็คชื่อ',
    printBtn:          'พิมพ์',
    excelBtn:          'Export Excel',
    // อักษรย่อในช่องตาราง — สีพื้นอย่างเดียวไม่พอ เหลือง/ฟ้าคอนทราสต์ต่ำเกินไป
    short: { present: 'ม', late: 'ส', leave: 'ล', absent: 'ข' },
  },

  manageTeaching: {
    pageTitle:               'ตารางการสอน (จัดการ)',
    classRoom:               'ห้องเรียน',
    filterClass:             'ชั้น',
    filterGender:            'เพศ',
    noRooms:                 'ไม่มีห้องเรียน',
    selectRoom:              'เลือกห้องเรียนเพื่อดูตารางสอน',
    addTeachingBtn:          'เพิ่มรายวิชา',
    noTeachings:             'ยังไม่มีการมอบหมายการสอนในห้องนี้',
    colCode:                 'รหัส',
    colSubjectName:          'ชื่อวิชา',
    colTeacher:              'ครูผู้สอน',
    colDayPeriod:            'วัน/คาบ',
    assignPeriodTitle:       'กำหนดคาบ',
    addTeachingModalTitle:   'เพิ่มรายวิชา',
    labelSubject:            'วิชา',
    subjectPlaceholder:      '-- เลือกวิชา --',
    allSubjectsAssigned:     'มีครูสอนทุกวิชาแล้ว',
    labelTeacher:            'ครูผู้สอน',
    teacherPlaceholder:      '-- เลือกครู --',
    labelDay:                'วัน',
    dayPlaceholder:          '-- เลือกวัน --',
    labelPeriod:             'คาบ',
    periodPlaceholder:       '-- เลือกคาบ --',
    noPeriods:               'ยังไม่มีคาบที่กำหนด',
    duplicatePeriod:         'คาบนี้ถูกเพิ่มแล้ว',
    confirmDeleteTitle:      'ยืนยันการลบ?',
    confirmDeleteBtn:        'ลบ',
    cancelDeleteBtn:         'ยกเลิก',
    deleteFailMsg:           'ไม่สามารถลบได้',
    errorShort:              'ข้อผิดพลาด',
  },

  timetableEditor: {
    pageTitle:          'จัดการตารางสอน',
    roomPlaceholder:    '-- เลือกห้องเรียน --',
    subjectsTitle:      'รายวิชาในหลักสูตร',
    dragHint:           '(ลากวางลงตาราง)',
    noSubjects:         'ไม่พบรายวิชาในหลักสูตรของห้องนี้',
    noPeriods:          'ยังไม่ได้กำหนดคาบเรียนของปีการศึกษานี้',
    colDay:             'วัน',
    periodNo:           (n) => `คาบ ${n}`,
    exportPdf:          'ดาวน์โหลด PDF',
    print:              'สั่งพิมพ์',
    empty:              'ว่าง',
    docTitle:           (room) => `ตารางสอนภาคศาสนา — ชั้น ${room}`,
    docFile:            (room) => `ตารางสอนศาสนา_${room}`,
    cannotDrop:         'วางไม่ได้',
    cellOccupied:       'ช่องนี้มีวิชาอยู่แล้ว',
    confirmDeleteSlot:  'ลบคาบสอนนี้ออกจากตาราง?',
    deleteSlotTitle:    'ลบออกจากตาราง',
    teacherModalTitle:  'เลือกครูผู้สอน',
    labelSlot:          'วัน/คาบ',
    conflictTitle:      'ครูมีชั่วโมงซ้อน',
    conflictBody:       (room) => `ครูมีวิชาสอนห้อง <strong>${room}</strong> ในคาบนี้อยู่แล้ว`,
    conflictAsk:        (action) => `ต้องการ${action}อยู่ดีหรือไม่?`,
    actionAdd:          'เพิ่ม',
    actionMove:         'ย้าย',
    addFail:            'ไม่สามารถเพิ่มคาบได้',
    moveFail:           'ไม่สามารถย้ายคาบได้',
    assignFail:         'ไม่สามารถเพิ่มวิชาลงตารางได้',
  },

  teachingTracking: {
    pageTitle:          'ติดตามการสอน',
    classRoom:          'ห้องเรียน',
    noRooms:            'ไม่มีห้องเรียน',
    selectRoom:         'เลือกห้องเรียนเพื่อดูสถานะการสอน',
    noTeachings:        'ยังไม่มีการมอบหมายการสอนในห้องนี้',
    colCode:            'รหัส',
    colSubjectName:     'ชื่อวิชา',
    colTeacher:         'ครูผู้สอน',
    colAttSessions:     'ครั้งที่เช็คชื่อ',
    colStudentsScore:   'นักเรียนมีคะแนน',
    times:              'ครั้ง',
    attendBtn:          'เช็คชื่อ',
    scoreBtn:           'คะแนน',
    viewLogBtn:         'บันทึกการสอน',
  },

  listTeachTracking: {
    pageTitle:    'บันทึกการสอน',
    breadHome:    'หน้าหลัก',
    breadCurrent: 'บันทึกการสอน',
    listTitle:    'รายการบันทึก',
    countTimes:   (n) => `${n} ครั้ง`,
    noRecords:    'ยังไม่มีบันทึกการสอน',
    colDate:      'วันที่',
    colTime:      'เวลา',
    colPeriod:    'คาบ',
    colTopic:     'หัวข้อที่สอน',
    colPresent:   'มา',
    colAbsent:    'ขาด',
    colLate:      'สาย',
    colLeave:     'ลา',
    colTotal:     'รวม',
    noTopic:      'ไม่ระบุหัวข้อ',
  },

  classGrade: {
    pageTitle:     'ตารางคะแนน (ภาคศาสนา)',
    classRoom:     'ห้องเรียน',
    noRooms:       'ไม่มีห้องเรียน',
    selectRoom:    'เลือกห้องเรียนเพื่อดูคะแนน',
    tabScores:     'คะแนน',
    tabAttendance: 'การเข้าเรียน',
    noSubjects:    'ยังไม่มีวิชาในห้องนี้',
    noAttendance:  'ยังไม่มีข้อมูลการเข้าเรียน',
    colNo:         'รหัส',
    colName:       'ชื่อ-สกุล',
    colAverage:    'ค่าเฉลี่ย',
    colPresent:    'มาเรียน',
    colAbsent:     'ขาด',
    colLate:       'สาย',
    colLeave:      'ลา',
    colTotal:      'รวม',
    genderLabel:   (g) => g === 'male' ? 'ชาย' : g === 'female' ? 'หญิง' : 'รวม',
  },

  advisorHome: {
    pageTitle:         'ห้องเรียนของฉัน (ภาคศาสนา)',
    noRoom:            'ไม่มีห้องเรียนในปีการศึกษานี้',
    labelStudents:     'นักเรียน',
    labelSubjects:     'รายวิชา',
    cardStudentsTitle: 'รายชื่อนักเรียน',
    cardStudentsDesc:  'ดูนักเรียนทั้งหมดในห้องเรียน',
    cardStudentsBtn:   'ดูนักเรียน',
    cardGradesTitle:   'คะแนน & การเข้าเรียน',
    cardGradesDesc:    'ดูคะแนนและการเข้าเรียนของนักเรียน',
    cardGradesBtn:     'ดูคะแนน',
    cardDormTitle:     'จัดการหอพัก',
    cardDormDesc:      'จัดนักเรียนเข้าหอพักและย้ายหลัง',
    cardDormBtn:       'จัดการหอพัก',
    cardLeaveTitle:    'แจ้งลานักเรียน',
    cardLeaveDesc:     'แจ้งลาครั้งเดียว มีผลทั้งภาคศาสนาและสามัญ',
    cardLeaveBtn:      'แจ้งลา',
    cardTimetableTitle:'ตารางสอน',
    cardTimetableDesc: 'ดูตารางสอนของห้องเรียนตลอดสัปดาห์',
    cardTimetableBtn:  'ดูตารางสอน',
  },

  teacherTimetable: {
    pageTitle:    'ตารางสอนครูรายคน',
    myPageTitle:  'ตารางสอนของฉัน',
    pickTeacher:  'เลือกครูเพื่อดูตารางสอน',
    colDay:       'วัน',
    periodNo:     (n) => `คาบ ${n}`,
    empty:        'ว่าง',
    noPeriods:    'ยังไม่ได้กำหนดคาบเรียนของปีการศึกษานี้',
    noTimetable:  (name) => `${name} ยังไม่มีตารางสอนในปีการศึกษานี้`,
    docTitle:     (name) => `ตารางสอนภาคศาสนา — ${name}`,
    docFile:      (name) => `ตารางสอนศาสนา_${name}`,
    docRoom:      (room) => `ชั้น ${room}`,
    noMyTimetable:'คุณยังไม่มีตารางสอนในปีการศึกษานี้',
    slotSummary:  (n) => `รวม ${n} คาบ/สัปดาห์`,
    conflictBadge:'มีคาบซ้อน',
    conflictHint: 'ช่องสีแดง = ครูถูกจัดสอนห้องอื่นในคาบเดียวกัน',
    exportPdf:    'ดาวน์โหลด PDF',
    print:        'สั่งพิมพ์',
  },

  advisorTimetable: {
    pageTitle:  'ตารางสอนห้องเรียน',
    colDay:     'วัน',
    periodNo:   (n) => `คาบ ${n}`,
    empty:      'ว่าง',
    noPeriods:  'ยังไม่ได้กำหนดคาบเรียนของปีการศึกษานี้',
    docTitle:   (room) => `ตารางสอนภาคศาสนา — ชั้น ${room}`,
    docFile:    (room) => `ตารางสอนศาสนา_${room}`,
    exportPdf:  'ดาวน์โหลด PDF',
    print:      'สั่งพิมพ์',
  },

  advisorLeave: {
    pageTitle:      'แจ้งลานักเรียน',
    breadcrumb:     'ที่ปรึกษาห้องเรียน (ภาคศาสนา)',
    noRoom:         'ไม่มีห้องเรียนในปีการศึกษานี้',
    linkedNote:     'แจ้งลาที่นี่ครั้งเดียว มีผลกับการเช็คชื่อทั้งภาคศาสนาและภาคสามัญ — ครูประจำชั้นสามัญไม่ต้องแจ้งซ้ำ และมีผลกับการเช็คชื่อครั้งถัดไปเท่านั้น',
    formTitle:      'เพิ่มการลา',
    labelDays:      'จำนวนวันลา',
    daysCustom:     'กำหนดเอง',
    daysUnit:       (n) => `${n} วัน`,
    daysHelp:       'เลือกจำนวนวันแล้วระบบจะตั้งวันที่สิ้นสุดให้อัตโนมัติ',
    labelStart:     'วันที่เริ่ม',
    labelEnd:       'วันที่สิ้นสุด',
    labelType:      'ประเภทการลา',
    typeSick:       'ลาป่วย',
    typePersonal:   'ลากิจ',
    labelNote:      'หมายเหตุ',
    notePlaceholder:'เหตุผลการลา (ถ้ามี)',
    labelStudents:  (n) => `เลือกนักเรียน (${n})`,
    selectAll:      'เลือกทั้งหมด',
    clearAll:       'ยกเลิกทั้งหมด',
    noStudents:     'ไม่พบนักเรียน',
    save:           'บันทึกการลา',
    saving:         'กำลังบันทึก...',
    listTitle:      'รายการลาทั้งหมด',
    colName:        'ชื่อ-สกุล',
    colRoom:        'ห้องสามัญ',
    colRange:       'ช่วงวันลา',
    colType:        'ประเภท',
    colSource:      'ผู้แจ้ง',
    colNote:        'หมายเหตุ',
    rangeTo:        'ถึง',
    noLeaves:       'ยังไม่มีรายการลา',
    homeLeave:      'ใบกลับบ้าน',
    noRegularStudy: 'ไม่มีทะเบียนสามัญปีนี้',
    noRegularHelp:  'นักเรียนที่ไม่มีทะเบียนภาคสามัญของปีนี้ แจ้งลาที่หน้านี้ไม่ได้ เพราะการลาผูกกับทะเบียนสามัญเพื่อให้มีผลทั้งสองภาค',
    overlapWarn:    (n) => `เลือกไว้ ${n} คน ที่มีการแจ้งลาช่วงวันนี้อยู่แล้ว — ระบบจะข้ามให้ ไม่บันทึกซ้ำ`,
    savedSomeTitle: (n) => `บันทึกการลา ${n} คน`,
    savedSomeText:  (n) => `ข้าม ${n} คน ที่มีการแจ้งลาช่วงวันนี้อยู่แล้ว`,
    savedNoneTitle: 'ไม่ได้บันทึกเพิ่ม',
    savedNoneText:  (n) => `นักเรียนที่เลือกทั้ง ${n} คน มีการแจ้งลาช่วงวันนี้อยู่แล้ว`,
    deleteTitle:    'ยืนยันการลบ',
    deleteText:     (name) => `ลบการลาของ ${name}?`,
    deleteConfirm:  'ลบ',
    cancel:         'ยกเลิก',
    onlyOwnDelete:  'ลบได้เฉพาะรายการที่แจ้งจากภาคศาสนา',
    savedTitle:     'บันทึกการลาสำเร็จ',
    deletedTitle:   'ลบสำเร็จ',
    errorTitle:     'เกิดข้อผิดพลาด',
    warnNoStudent:  'กรุณาเลือกนักเรียนอย่างน้อย 1 คน',
    warnNoStudentTitle: 'ยังไม่ได้เลือกนักเรียน',
    warnRangeTitle: 'ช่วงวันที่ไม่ถูกต้อง',
    warnRange:      'วันที่เริ่มต้องไม่เกินวันที่สิ้นสุด',
  },

  advisorGrade: {
    pageTitle:     'คะแนน & การเข้าเรียน',
    noRoom:        'ไม่มีห้องเรียนในปีการศึกษานี้',
    tabScores:     'คะแนน',
    tabAttendance: 'การเข้าเรียน',
    noSubjects:    'ยังไม่มีวิชาในห้องนี้',
    noAttendance:  'ยังไม่มีข้อมูลการเข้าเรียน',
    colNo:         'รหัส',
    colName:       'ชื่อ-สกุล',
    colAverage:    'ค่าเฉลี่ย',
    colPresent:    'มาเรียน',
    colAbsent:     'ขาด',
    colLate:       'สาย',
    colLeave:      'ลา',
    colTotal:      'รวม',
  },

  advisorStudents: {
    pageTitle:     'รายชื่อนักเรียน',
    noRoom:        'ไม่มีห้องเรียนในปีการศึกษานี้',
    totalStudents: 'จำนวนนักเรียน',
    noStudents:    'ยังไม่มีนักเรียนในห้องนี้',
    colNo:         'รหัส',
    colName:       'ชื่อ-สกุล',
    colArabicName: 'ชื่อภาษาอาหรับ',
    colGender:     'เพศ',
    colRegularClass: 'ชั้นสามัญ',
    colDorm:       'หอพัก',
    viewInfo:      'แสดงข้อมูล',
    dormTip:       'ดูรายชื่อนักเรียนร่วมหอ',
    dormTitle:     (name) => `นักเรียนในหอ ${name}`,
    dormVillage:   (v) => `หมู่บ้าน${v}`,
    dormEmpty:     'ไม่พบนักเรียนในหอนี้',
    dormLoading:   'กำลังโหลด...',
    dormColNo:     'ที่',
    dormColClass:  'ชั้นสามัญ',
    dormColIslamic: 'ชั้นศาสนา',
  },

  manageRoom: {
    pageTitle:        'จัดการห้องเรียน (ภาคศาสนา)',
    breadHome:        'หน้าหลัก',
    breadCurrent:     'ห้องเรียนภาคศาสนา',
    addBtn:           'เพิ่มห้อง',
    filterAllGender:  '-- ทุกเพศ --',
    filterAllClass:   '-- ทุกชั้น --',
    listTitle:        'รายการห้องเรียน',
    noRooms:          'ไม่มีข้อมูลห้องเรียน',
    colClass:         'ชั้น',
    colRoom:          'ห้อง',
    colGender:        'เพศ',
    colProgram:       'โปรแกรม',
    colAdvisor:       'ครูที่ปรึกษา',
    colStudents:      'นักเรียน',
    modalAddTitle:    'เพิ่มห้องเรียน',
    modalEditTitle:   'แก้ไขห้องเรียน',
    labelClass:       'ชั้น',
    classPlaceholder: '-- เลือกชั้น --',
    labelRoom:        'ห้อง (เลขห้อง)',
    roomPlaceholder:  'เช่น 1, 2, A',
    labelGender:      'เพศนักเรียน',
    labelProgram:     'โปรแกรม',
    labelAdvisor:     'ครูที่ปรึกษา',
    noneOption:       '-- ไม่มี --',
    incompleteTitle:  'ข้อมูลไม่ครบ',
    incompleteMsg:    'กรุณากรอกเลขห้อง เพศ และชั้น',
    successTitle:     'สำเร็จ',
    errorTitle:       'ข้อผิดพลาด',
    successUpdate:    'แก้ไขห้องเรียนแล้ว',
    successAdd:       'เพิ่มห้องเรียนแล้ว',
    successDelete:    'ลบห้องเรียนแล้ว',
    confirmDelete:    (r) => `ลบห้อง ${r}?`,
    confirmBtn:       'ลบ',
    cancelBtn:        'ยกเลิก',
    genderLabel:      { m: 'ชาย', f: 'หญิง' },
  },

  manageCurriculum: {
    pageTitle:           'จัดการหลักสูตร (ภาคศาสนา)',
    breadHome:           'หน้าหลัก',
    breadCurrent:        'หลักสูตรภาคศาสนา',
    syllabusTitle:       'หลักสูตรทั้งหมด',
    assignedTitle:       'การมอบหมายหลักสูตร',
    addBtn:              'เพิ่ม',
    assignBtn:           'มอบหมาย',
    colSylYear:          'ปีหลักสูตร',
    noData:              'ไม่มีข้อมูล',
    colSyllabus:         'หลักสูตร',
    colClass:            'ชั้น',
    colProgram:          'โปรแกรม',
    colSubjects:         (n) => `${n} รายวิชา`,
    modalAddSylTitle:    'เพิ่มหลักสูตร',
    labelSylYear:        'ปีหลักสูตร (เช่น 2567)',
    modalAssignTitle:    'มอบหมายหลักสูตร',
    labelSyllabus:       'หลักสูตร',
    sylPlaceholder:      '-- เลือกหลักสูตร --',
    labelClass:          'ชั้น',
    classPlaceholder:    '-- เลือกชั้น --',
    labelProgram:        'โปรแกรม',
    noneOption:          '-- ไม่มี --',
    successTitle:        'สำเร็จ',
    errorTitle:          'ข้อผิดพลาด',
    incompleteTitle:     'ข้อมูลไม่ครบ',
    confirmBtn:          'ลบ',
    cancelBtn:           'ยกเลิก',
    addedSyl:            'เพิ่มหลักสูตรแล้ว',
    deletedSyl:          'ลบหลักสูตรแล้ว',
    confirmDeleteSyl:    (y) => `ลบหลักสูตรปี ${y}?`,
    assignedSuccess:     'มอบหมายหลักสูตรแล้ว',
    cancelledAssign:     'ยกเลิกการมอบหมายแล้ว',
    confirmCancelAssign: 'ยกเลิกการมอบหมายหลักสูตร?',
    incompleteAssignMsg: 'กรุณาเลือกหลักสูตรและชั้น',
  },

  manageSubject: {
    pageTitle:        'จัดการรายวิชา (ภาคศาสนา)',
    breadHome:        'หน้าหลัก',
    breadSyllabus:    'หลักสูตร',
    breadCurrent:     'รายวิชา',
    addBtn:           'เพิ่มรายวิชา',
    listTitle:        (n) => `รายวิชา (${n})`,
    noSubjects:       'ยังไม่มีรายวิชา',
    colCode:          'รหัสวิชา',
    colName:          'ชื่อวิชา',
    modalAddTitle:    'เพิ่มรายวิชา',
    modalEditTitle:   'แก้ไขรายวิชา',
    labelCode:        'รหัสวิชา ภาคเรียนที่ 1',
    labelCode2:       'รหัสวิชา ภาคเรียนที่ 2',
    codePlaceholder:  'เช่น IS101',
    code2Placeholder: 'เช่น IS102',
    code2Hint:        'เว้นว่างได้ถ้าสอนเฉพาะภาคเรียนที่ 1',
    labelName:        'ชื่อวิชา',
    namePlaceholder:  'ชื่อวิชา',
    incompleteTitle:  'ข้อมูลไม่ครบ',
    incompleteMsg:    'กรุณากรอกรหัสวิชาภาคเรียนที่ 1 และชื่อวิชา',
    successTitle:     'สำเร็จ',
    errorTitle:       'ข้อผิดพลาด',
    successUpdate:    'แก้ไขรายวิชาแล้ว',
    successAdd:       'เพิ่มรายวิชาแล้ว',
    successDelete:    'ลบรายวิชาแล้ว',
    confirmDelete:    (c) => `ลบรายวิชา ${c}?`,
    confirmBtn:       'ลบ',
    cancelBtn:        'ยกเลิก',
  },

  manageStudents: {
    pageTitle:          (r) => `นักเรียนในห้อง ${r}`,
    breadHome:          'หน้าหลัก',
    breadRooms:         'ห้องเรียน',
    breadCurrent:       'นักเรียน',
    filterAllClass:     '-- ชั้น --',
    filterAllGender:    '-- เพศ --',
    filterAllRoom:      '-- ห้อง --',
    selectRoom:         'กรุณาเลือกห้องเรียนจากรายการด้านบน',
    addStudentTitle:    'เพิ่มนักเรียน',
    labelStudentId:     'รหัสนักเรียน',
    searchPlaceholder:  'กรอกรหัสนักเรียน',
    notFound:           (id) => `ไม่พบนักเรียนรหัส ${id}`,
    enrollBtn:          'ลงทะเบียนเข้าห้องนี้',
    searchHint:         'ค้นหาด้วยรหัสนักเรียน แล้วกดลงทะเบียน',
    listTitle:          (n) => `รายชื่อนักเรียน (${n} คน)`,
    noStudents:         'ยังไม่มีนักเรียนในห้องนี้',
    colNo:              'รหัส',
    colName:            'ชื่อ-สกุล',
    colArabicName:      'ชื่อภาษาอาหรับ',
    colGender:          'เพศ',
    colStatus:          'สถานะ',
    statusBadge:        { 0: 'ออก', 1: 'กำลังเรียน', 3: 'นักเรียนใหม่' },
    noInfo:             'ไม่มีข้อมูล',
    genderLabel:        (g) => g === 'm' ? 'ชาย' : 'หญิง',
    labelGender:        'เพศ',
    labelStatus:        'สถานะ',
    confirmUnenroll:    (name) => `นำ ${name} ออกจากห้อง?`,
    successTitle:       'สำเร็จ',
    errorTitle:         'ข้อผิดพลาด',
    enrolledSuccess:    'ลงทะเบียนนักเรียนแล้ว',
    unenrolledSuccess:  'นำนักเรียนออกแล้ว',
    confirmUnenrollBtn: 'นำออก',
    cancelBtn:          'ยกเลิก',
    editBtn:            'แก้ไขข้อมูล',
    changeStatusTitle:  'แก้ไขสถานะ',
  },

  updateStudent: {
    breadHome:        'หน้าหลัก',
    breadRooms:       'ห้องเรียน',
    breadStudents:    'นักเรียน',
    breadCurrent:     'แก้ไขข้อมูลนักเรียน',
    pageTitle:        'แก้ไขข้อมูลนักเรียน',
    cardTitle:        'ข้อมูลประวัติส่วนตัวนักเรียน',

    photoNone:        'ยังไม่มีรูป',
    choosePhoto:      'เลือกรูป',
    uploadPhoto:      'อัปโหลดรูป',
    preparingPhoto:   'กำลังเตรียมรูป',

    secPersonal:      'ข้อมูลส่วนตัว',
    secSibling:       'ข้อมูลพี่น้อง',
    secAddressOld:    'ภูมิลำเนาเดิม',
    secAddressCurrent:'ที่อยู่ปัจจุบัน',
    secFather:        'ข้อมูลบิดา',
    secMother:        'ข้อมูลมารดา',
    secGuardian:      'สถานะและผู้ปกครอง',
    secOther:         'ข้อมูลอื่นๆ',

    fIdnumber:        'รหัสประจำตัว',
    fName:            'ชื่อ-สกุล',
    fArabicName:      'ชื่อภาษาอาหรับ',
    fGender:          'เพศ',
    male:             'ชาย',
    female:           'หญิง',
    fBlood:           'หมู่เลือด',
    fIdcard:          'เลขประจำตัวประชาชน',
    fBirthdate:       'วัน เดือน ปี เกิด',
    birthdateHint:    'เช่น 22/07/2550',
    fNationality:     'สัญชาติ',
    fRace:            'เชื้อชาติ',
    fReligion:        'ศาสนา',

    fChildNumber:     'เป็นบุตรคนที่',
    fSiblingTotal:    'จำนวนพี่น้องร่วมสายโลหิต',
    unitPerson:       'คน',
    fSiblingMale:     'ชาย',
    fSiblingFemale:   'หญิง',

    fHomeId:          'เลขรหัสประจำบ้าน',
    fAddress:         'ที่อยู่',
    fSubDistrict:     'ตำบล',
    fDistrict:        'อำเภอ',
    fProvince:        'จังหวัด',
    fZipcode:         'รหัสไปรษณีย์',

    fName2:           'ชื่อ',
    fJob:             'อาชีพ',
    fIncomeYear:      'รายได้/ปี',
    fPhone:           'เบอร์โทร',

    fAverageIncome:   'รายได้เฉลี่ยครอบครัว/ปี',
    fParentStatus:    'สถานะบิดามารดา',
    stTogether:       'อยู่ด้วยกัน',
    stSeparated:      'แยกกันอยู่',
    stDivorced:       'หย่าร้าง',
    fGuardianType:    'ผู้ปกครอง',
    guardianDad:      'บิดา',
    guardianMom:      'มารดา',
    guardianOther:    'อื่นๆ',
    fRelation:        'ความเกี่ยวข้อง',
    fExpensePayer:    'ผู้ออกค่าใช้จ่าย',

    fFavoriteSport:   'กีฬาที่สนใจ',
    fFavoriteSubject: 'วิชาที่ชอบ',
    fFutureStudy:     'แนวทางการศึกษาต่อ',
    fFutureJob:       'อาชีพในอนาคต',

    saveBtn:          'บันทึกข้อมูล',
    saveSuccessTitle: 'สำเร็จ',
    saveSuccessText:  'บันทึกข้อมูลนักเรียนเรียบร้อย',
    loadErrorTitle:   'เกิดข้อผิดพลาด',
    loadErrorText:    'ไม่สามารถดึงข้อมูลนักเรียนได้ กรุณาลองใหม่อีกครั้ง',
    saveErrorTitle:   'เกิดข้อผิดพลาด',
    saveErrorText:    'ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง',

    invalidFileTitle: 'ไฟล์ไม่ถูกต้อง',
    imageOnlyText:    'กรุณาเลือกรูปภาพเท่านั้น',
    photoLargeTitle:  'รูปยังมีขนาดใหญ่เกินไป',
    photoLargeText:   'กรุณาเลือกรูปที่เล็กลง หรือครอบ/ลดขนาดรูปก่อนอัปโหลด',
    uploadOkTitle:    'อัปโหลดรูปสำเร็จ',
    uploadFailTitle:  'อัปโหลดรูปไม่สำเร็จ',
    uploadFailText:   'กรุณาลองใหม่อีกครั้ง',
  },

  // ระดับชั้นภาคศาสนา — คีย์ตรงกับ server/utils/islamicLevels.js (ISLAMIC_LEVELS[].key)
  islamicLevel: {
    ibtidai:    'ตอนต้น (อิบตีดาอีย์)',
    mutawassit: 'ตอนกลาง (มูตาวัซซิต)',
    sanawi:     'ตอนปลาย (ซานาวีย์)',
    aip:        'ห้องพิเศษ AIP',
    stp:        'ห้องพิเศษ STP',
  },

  // ป้ายระดับความเสี่ยง + ชื่อแกน + ชื่อบทบาท (ใช้ร่วมกันทั้งหน้าติดตามและหน้าติดตามการดูแล)
  risk: {
    red:              'เสี่ยงสูง',
    orange:           'เสี่ยง',
    yellow:           'เฝ้าระวัง',
    green:            'ปกติ',
    axisAttendance:   'การเข้าเรียน',
    axisBehavior:     'ความประพฤติ',
    axisConcern:      'แจ้งดูแล',
    roleAcademicHead: 'หัวหน้าวิชาการศาสนา',
    roleLevelHead:    'หัวหน้าระดับ',
    roleAdvisor:      'ครูประจำชั้นศาสนา',
    roleFallback:     'ติดตามนักเรียน',
    whoAdvisor:       'ครูประจำชั้นศาสนา',
    whoHead:          'หัวหน้าระดับ',
  },

  tracking: {
    pageTitle:       'ระบบติดตามนักเรียน (ภาคศาสนา)',
    pageSubtitle:    'รวมสัญญาณเตือนแบบเรียลไทม์ — ขาดเรียน · ความประพฤติ · แจ้งดูแล · สุขภาพ',
    breadcrumb:      'ติดตามนักเรียนภาคศาสนา',
    cardHighRisk:    'เสี่ยงสูง',
    cardRisk:        'เสี่ยง',
    cardWatch:       'เฝ้าระวัง',
    cardLowBehavior: 'ความประพฤติต่ำกว่าเกณฑ์',
    cardConcern:     'ถูกแจ้งดูแล',
    breakdownTitle:  'แยกตามสาเหตุ',
    breakdownHelp:   'นับทุกด้านที่อยู่ในระดับเดียวกับระดับรวมของนักเรียน คนหนึ่งจึงถูกนับได้หลายด้าน ผลรวมจึงมากกว่ายอดในการ์ดได้',
    breakdownEmpty:  'ไม่มีนักเรียนในระดับนี้',
    noAttendanceWarn:(n) => `ยังไม่มีการเช็คชื่อภาคศาสนามากพอสำหรับนักเรียน ${n} คน — แกนการเข้าเรียนของคนกลุ่มนี้จึงยังขึ้นว่าปกติ`,
    filterGender:    'เพศ',
    filterClass:     'ชั้น',
    filterRoom:      'ห้องเรียน',
    filterAll:       'ทั้งหมด',
    filterRisk:      'ระดับความเสี่ยง',
    riskAll:         'ทั้งหมด',
    listTitle:       'จัดอันดับนักเรียนตามความเสี่ยงรวม',
    found:           (n) => `พบ ${n} คน`,
    empty:           'ไม่พบนักเรียนที่เข้าเกณฑ์ตามตัวกรองนี้',
    printBtn:        'พิมพ์',
    printBlocked:    'พิมพ์ไม่ได้',
    printBlockedText:'กรุณาอนุญาต popup ของเบราว์เซอร์',
    viewTable:       'มุมมองตาราง',
    viewCard:        'มุมมองการ์ด',
    colNo:           '#',
    colStudent:      'นักเรียน',
    colRoom:         'ห้องศาสนา',
    colRegularRoom:  'ห้องสามัญ',
    colDorm:         'หอพัก',
    colOverall:      'ความเสี่ยง',
    colAttendance:   'เข้าเรียน',
    colBehavior:     'ความประพฤติ',
    colConcern:      'แจ้งดูแล',
    colHealth:       'สุขภาพ',
    tipOverall:      'ระดับรวม = แกนที่แย่ที่สุดใน 3 ด้าน (เข้าเรียน/ความประพฤติ/แจ้งดูแล) — เสี่ยงสูง > เสี่ยง > เฝ้าระวัง > ปกติ',
    tipAttendance:   'ขาด/สาย/ลา และ % การขาด — เสี่ยงสูง มากกว่า 40%, เสี่ยง 20–40%, เฝ้าระวัง 10–20% (เริ่มนับเมื่อเช็คชื่อครบ 5 คาบขึ้นไป)',
    tipBehavior:     'คะแนนความประพฤติที่เหลือจาก 100 (หักโดยฝ่ายปกครอง บวกคืนด้วยงานจิตอาสาที่ทำเสร็จแล้ว)',
    tipConcern:      'เรื่องที่ครูแจ้งดูแลและยังไม่ยุติ — ผูกกับตัวนักเรียน ไม่แยกภาค จึงรวมเรื่องที่ครูภาคสามัญแจ้งด้วย',
    tipHealth:       'มีข้อมูลสุขภาพ/โรคประจำตัว หรือ BMI นอกเกณฑ์',
    absentShort:     (n, pct) => `ขาด ${n} · ${pct}%`,
    lateLeave:       (late, leave) => `สาย ${late} · ลา ${leave}`,
    pointsLeft:      (n) => `${n} คะแนน`,
    concernCount:    (n) => `${n} เรื่อง`,
    detailBtn:       'ดูรายละเอียด',
    clickRowHint:    'กดที่แถวเพื่อดูรายละเอียดนักเรียน',
    bmiOut:          (v) => `BMI ${v} นอกเกณฑ์`,
    hasHealthInfo:   'มีข้อมูลสุขภาพ/โรคประจำตัว',
    printTitle:      'จัดอันดับนักเรียนตามความเสี่ยงรวม (ภาคศาสนา)',
    printConditions: 'เงื่อนไข',
    printGenderAll:  'ทุกเพศ',
    printClassAll:   'ทุกชั้น',
    printRoomAll:    'ทุกห้อง',
    printSummary:    (total, red, orange, yellow, green) => `รวม ${total} คน (เสี่ยงสูง ${red} / เสี่ยง ${orange} / เฝ้าระวัง ${yellow} / ปกติ ${green})`,
    printAt:         'พิมพ์เมื่อ',
  },

  trackingDetail: {
    breadcrumb:      'ติดตามนักเรียนภาคศาสนา',
    pageTitle:       'รายละเอียดการติดตามนักเรียน',
    back:            'กลับ',
    notFound:        'ไม่พบข้อมูลนักเรียน',
    noAccess:        'ไม่มีสิทธิ์ดูข้อมูลนักเรียนคนนี้',
    infoRoom:        'ห้องศาสนา',
    infoRegular:     'ห้องสามัญ',
    infoProgram:     'โปรแกรม',
    sumAttendance:   'การเข้าเรียนภาคศาสนา',
    sumPresent:      'มาเรียน',
    sumAbsent:       'ขาด',
    sumLate:         'สาย',
    sumLeave:        'ลา',
    sumTotal:        'รวม',
    sumRate:         'ขาด (%)',
    bySubject:       'การเข้าเรียนแยกตามรายวิชา',
    noSubjectAtt:    'ยังไม่มีข้อมูลการเช็คชื่อภาคศาสนา',
    colSubject:      'รายวิชา',
    colTeacher:      'ผู้สอน',
    attDetail:       'รายการเช็คชื่อ (ล่าสุดก่อน)',
    noAttDetail:     'ยังไม่มีรายการเช็คชื่อ',
    colDate:         'วันที่',
    colPeriod:       'คาบ',
    colStatus:       'สถานะ',
    colTopic:        'หัวข้อที่สอน',
    statusPresent:   'มาเรียน',
    statusAbsent:    'ขาด',
    statusLate:      'สาย',
    statusLeave:     'ลา',
    attDetailMore:   (shown, total) => `แสดง ${shown} รายการล่าสุด จากทั้งหมด ${total} รายการ`,
    scores:          'คะแนนรายวิชาศาสนา',
    scoresNote:      'เป็นข้อมูลประกอบ ไม่ได้นำมาคิดระดับความเสี่ยง — คะแนนกรอกครั้งเดียวตอนปลายภาค (เต็ม 50 ต่อภาค) จึงมาสายเกินกว่าจะเป็นสัญญาณเตือน',
    noScores:        'ยังไม่มีคะแนน',
    colTerm1:        'ภาค 1',
    colTerm2:        'ภาค 2',
    colScoreAvg:     'เฉลี่ย',
    conduct:         'ความประพฤติ',
    conductRemaining:'คะแนนที่เหลือ',
    conductDeducted: 'ถูกหัก',
    conductMerit:    'ได้คืน (จิตอาสา)',
    noConduct:       'ยังไม่มีการหักคะแนน',
    colRule:         'เรื่อง',
    colPoints:       'คะแนน',
    colBy:           'ผู้บันทึก',
    merits:          'งานจิตอาสา',
    noMerits:        'ยังไม่มีงานจิตอาสา',
    colActivity:     'กิจกรรม',
    meritAssigned:   'มอบหมายแล้ว',
    meritCompleted:  'ทำเสร็จแล้ว',
    meritCancelled:  'ยกเลิก',
    concerns:        'เรื่องที่แจ้งดูแล',
    concernsNote:    'ผูกกับตัวนักเรียน ไม่แยกภาค จึงรวมเรื่องที่ครูภาคสามัญแจ้งด้วย',
    noConcerns:      'ไม่มีเรื่องที่แจ้งดูแล',
    colCategory:     'ด้าน',
    colDetail:       'รายละเอียด',
    concernOpen:     'เปิดอยู่',
    concernProgress: 'กำลังดูแล',
    concernResolved: 'ยุติแล้ว',
    // ด้านของเรื่องที่แจ้งดูแล — คีย์ตรงกับ tb_student_concern.concern_category
    catLearning:     'ด้านการเรียน',
    catHealth:       'ด้านสุขภาพ',
    catFamily:       'ด้านครอบครัว',
    catEmotional:    'ด้านอารมณ์/จิตใจ',
    catPeer:         'ด้านเพื่อน/สังคม',
    catOther:        'อื่นๆ',
    health:          'น้ำหนัก/ส่วนสูง',
    noHealth:        'ยังไม่มีข้อมูลน้ำหนัก/ส่วนสูง',
    colMonth:        'เดือน',
    colHeight:       'ส่วนสูง (ซม.)',
    colWeight:       'น้ำหนัก (กก.)',
    colBmi:          'BMI',
    healthNotes:     'ข้อมูลสุขภาพ',
    healthDrug:      'แพ้ยา',
    healthFood:      'แพ้อาหาร',
    healthSyndrome:  'โรคประจำตัว',
    healthEver:      'เคยเป็นโรค',
    healthFacing:    'กำลังรักษา',
    healthAccident:  'ประวัติอุบัติเหตุ',
  },

  careTracking: {
    pageTitle:       'ติดตามการดูแลนักเรียน (ภาคศาสนา)',
    pageTitleRead:   'สถานะติดตามการดูแลนักเรียน (ภาคศาสนา)',
    breadcrumb:      'ติดตามนักเรียนภาคศาสนา',
    subtitle:        'ติ๊กถูกเมื่อดำเนินการตามขั้นตอนแล้ว — ขั้นของครูประจำชั้นติ๊กได้เฉพาะครูประจำชั้นศาสนาห้องนั้น ขั้นของหัวหน้าระดับติ๊กได้เฉพาะหัวหน้าระดับของระดับนั้น',
    subtitleRead:    'ดูสถานะการดำเนินการของครูประจำชั้นศาสนาและหัวหน้าระดับ (ดูอย่างเดียว) — ช่องที่ติ๊กแล้วชี้เพื่อดูว่าใครบันทึก เมื่อไร',
    stepsTitle:      'ขั้นตอนดูแล',
    criteria:        'เกณฑ์',
    criteriaAttendance:'เฝ้าระวัง ขาด 10–20% · เสี่ยง 20–40% · เสี่ยงสูง มากกว่า 40%',
    criteriaBehavior:'เฝ้าระวัง คะแนนความประพฤติต่ำกว่า 90 · เสี่ยงสูง ต่ำกว่า 70',
    cumulativeNote:  'นักเรียนระดับสูงต้องผ่านขั้นตอนของระดับต่ำกว่าด้วย เช่น เสี่ยงสูงต้องมีครบทุกช่อง จึงนับว่า "ครบ"',
    progressNote:    'ใต้ช่องที่ติ๊กแล้วจะแสดงตัวเลขตอนติ๊ก → ตอนนี้ เพื่อดูความคืบหน้าหลังดำเนินการ:',
    trendBetter:     'ดีขึ้น',
    trendWorse:      'แย่ลง',
    trendSame:       'เท่าเดิม',
    progressLegacy:  '(ช่องที่ติ๊กไว้ก่อนมีระบบนี้จะไม่มีตัวเลขเทียบ)',
    lockedTip:       'ยกเลิกติ๊กไม่ได้ — ตัวเลขเปลี่ยนไปจากตอนติ๊กแล้ว ติ๊กใหม่จะได้ตัวเลขของวันนี้แทน (ถ้าติ๊กผิดให้แจ้งผู้ดูแลระบบ)',
    lockedNote:      'ช่องที่ตัวเลขขยับไปจากตอนติ๊กแล้วจะล็อกไม่ให้ยกเลิกติ๊ก — เพราะยกเลิกแล้วติ๊กใหม่ ระบบจะเก็บตัวเลขของวันที่ติ๊กใหม่แทน ตัวเลขตั้งต้นที่ใช้วัดความคืบหน้าจะหายไป',
    cardPending:     'ยังดำเนินการไม่ครบ',
    cardComplete:    'ดำเนินการครบแล้ว',
    filterLevel:     'ระดับ',
    filterLevelAll:  'ทุกระดับ',
    filterStatus:    'สถานะ',
    statusPending:   'ยังไม่ครบ',
    statusComplete:  'ครบแล้ว',
    statusAll:       'ทั้งหมด',
    listTitle:       'รายชื่อนักเรียน',
    count:           (n) => `${n} คน`,
    empty:           'ไม่มีนักเรียนที่เข้าเกณฑ์ตามตัวกรองนี้',
    clickNameHint:   'กดชื่อเพื่อดูรายละเอียดนักเรียน',
    colNo:           '#',
    colStudent:      'นักเรียน',
    colRoom:         'ห้องศาสนา',
    colLevelInfo:    'ระดับ / ข้อมูล',
    colContact:      'เบอร์ผู้ปกครอง',
    colStatus:       'สถานะ',
    colContract:     'สัญญา',
    stepHeadYellow:  'พูดคุย/ตักเตือน',
    stepHeadOrange:  'โทรแจ้งผู้ปกครอง/ทำสัญญา',
    complete:        'ครบ',
    missing:         (n, total) => `ขาด ${n}/${total}`,
    notYet:          'ยังไม่ถึง',
    notYetTip:       (level) => `ยังไม่ถึงระดับ${level} — ยังไม่ต้องดำเนินการขั้นนี้`,
    notAllowedTip:   (who) => `ยังไม่ได้ดำเนินการ — ติ๊กได้เฉพาะ${who}`,
    pendingTip:      (label) => `ยังไม่ได้ดำเนินการ: ${label}`,
    noRecorder:      'ไม่ระบุผู้บันทึก',
    tickedAt:        'ตอนติ๊ก',
    nowAt:           'ตอนนี้',
    addNote:         'เพิ่มหมายเหตุ (ไม่บังคับ)',
    noteTitle:       (name) => `${name} · หมายเหตุสั้น ๆ (ไม่บังคับ)`,
    noteSave:        'บันทึก',
    noteCancel:      'ยกเลิก',
    noPhone:         'ไม่มีเบอร์',
    attendanceInfo:  (a) => `ขาด ${a.absent} ครั้ง (${a.absenceRate}%) · สาย ${a.late} · ลา ${a.leave}`,
    behaviorInfo:    (a) => `เหลือ ${a.remaining} คะแนน (ถูกหัก ${a.deducted}${a.merited ? ` · ได้คืน ${a.merited}` : ''})`,
    printTitle:      'ติดตามการดูแลนักเรียน (ภาคศาสนา)',
    printSummary:    (total, complete, pending) => `รวม ${total} คน (ครบ ${complete} / ยังไม่ครบ ${pending})`,
    printLegend:     '✔ ดำเนินการแล้ว · ☐ ยังไม่ดำเนินการ · - ยังไม่ถึงระดับของขั้นนี้',
    contractBtn:     'พิมพ์หนังสือสัญญา (A4)',
    contractBtnShort:'พิมพ์สัญญา',
    contractTitle:   'หนังสือสัญญา',
    contractHint:    'ช่องที่ระบบไม่มีข้อมูลจะพิมพ์เป็นเส้นประให้เขียนด้วยมือ',
    contractPrint:   'พิมพ์ A4',
    contractClose:   'ปิด',
    contractError:   'เปิดหนังสือสัญญาไม่สำเร็จ',
    saveError:       'บันทึกไม่สำเร็จ',
    loadError:       'โหลดข้อมูลไม่สำเร็จ',
    busyTitle:       'ระบบกำลังหนาแน่น',
    busyText:        'ตอนนี้มีผู้ใช้งานหน้านี้พร้อมกันหลายคน กรุณารอสักครู่แล้วลองใหม่อีกครั้ง',
    busyRetry:       'ลองใหม่อีกครั้ง',
    busyLater:       'ไว้ก่อน',
    busyUnderstood:  'เข้าใจแล้ว',
    retryText:       'กรุณาลองใหม่อีกครั้ง',
  },

  // ---- หมวดวิชาการภาคศาสนา (หัวหน้าวิชาการศาสนา pos 57) ----
  // ตัวกรองชุดนี้ใช้ร่วมกันทุกหน้าในหมวด (islamic-academic/academicShared.js)
  academic: {
    groupTitle:   'วิชาการภาคศาสนา',
    filterYear:   'ปีการศึกษา',
    filterClass:  'ชั้น',
    filterRoom:   'ห้อง',
    filterGender: 'เพศ',
    allClasses:   'ทุกชั้น',
    allRooms:     'ทุกห้อง',
    allGenders:   'ทุกเพศ',

    // ติดตามงานครูประจำชั้นศาสนา — สามงานที่มีร่องรอยในฐานข้อมูลให้ตรวจได้จริง
    // (หอพัก / ขั้นตอนดูแลนักเรียน / แจ้งลา + การเข้าใช้ระบบ) ดูเหตุผลที่หัวไฟล์
    // server/models/islamicAdvisorTrackingModel.js
    advisorTasks: {
      pageTitle:          'ติดตามงานครูประจำชั้นศาสนา',
      subtitle:           'ห้องไหนยังไม่ได้ทำ — กดที่แถวเพื่อดูรายชื่อ (อ่านอย่างเดียว)',
      onlyPending:        'เฉพาะห้องที่มีงานค้าง',

      statDormMissing:    'นักเรียนที่ยังไม่มีทะเบียนหอพัก',
      statDormMissingSub: (n) => `ค้างอยู่ ${n} ห้อง`,
      statCarePending:    'นักเรียนที่ขั้นตอนดูแลยังไม่ครบ',
      statCarePendingSub: (n) => `ใน ${n} ห้อง`,
      statLeaves:         'ใบลาที่แจ้งในปีนี้',
      statLeavesSub:      'เฉพาะที่ครูประจำชั้นศาสนาแจ้ง',
      statStale:          (d) => `ครูที่ไม่ได้เข้าระบบเกิน ${d} วัน`,
      statStaleSub:       (never, total) => `ไม่เคยเข้าเลย ${never} คน · ครูประจำชั้นทั้งหมด ${total} คน`,

      listTitle:          'รายห้อง',
      roomCount:          (n) => `${n} ห้อง`,
      dormHint:           'โรงเรียนเป็นแบบประจำเต็มรูปแบบ นักเรียนทุกคนต้องมีทะเบียนหอพัก — คนที่ยังไม่มีคือยังไม่ได้ลงทะเบียน ไม่ใช่นักเรียนไปกลับ',
      empty:              'ไม่มีห้องที่ตรงกับตัวกรองนี้',
      allDone:            'ทุกห้องในตัวกรองนี้ไม่มีงานค้าง',
      footerHint:         'อ่านอย่างเดียว — การจัดหอพัก แจ้งลา และติ๊กขั้นตอนดูแล ทำที่เมนูของครูประจำชั้นศาสนา',

      colRoom:            'ชั้น/ห้อง',
      colAdvisor:         'ครูประจำชั้น / เข้าระบบล่าสุด',
      colStudents:        'นักเรียน',
      colDorm:            'ทะเบียนหอพัก',
      colCare:            'ขั้นตอนดูแลนักเรียน',
      colLeave:           'แจ้งลา',

      noAdvisor:          'ยังไม่กำหนดครูประจำชั้น',
      inactiveAccount:    'บัญชีถูกปิดใช้งาน',
      neverLogin:         'ไม่เคยเข้าระบบ',
      loginToday:         'เข้าระบบวันนี้',
      loginDays:          (n) => `${n} วันก่อน`,

      dormComplete:       'ครบ',
      dormMissing:        (n) => `ขาด ${n}`,
      careNone:           'ไม่มีคนติดเกณฑ์',
      careComplete:       (n) => `ครบ ${n} คน`,
      carePending:        (pending, total) => `ค้าง ${pending}/${total} คน`,

      tab_dorm:           'ทะเบียนหอพัก',
      tab_care:           'ขั้นตอนดูแล',
      tab_leave:          'ใบลาที่แจ้ง',
      loading:            'กำลังโหลด...',
      detailEmpty:        'ไม่มีข้อมูลในหัวข้อนี้',

      colStudent:         'นักเรียน',
      colDormName:        'หอพัก',
      colCheckin:         'วันเข้าหอ',
      noDorm:             'ยังไม่มีหอพัก',

      colRisk:            'ระดับ',
      colWhy:             'ติดเกณฑ์เพราะ',
      colSteps:           'ขั้นตอนของครูประจำชั้น',
      stepDoneBy:         (name, when) => `ทำแล้วโดย ${name}${when ? ` เมื่อ ${when}` : ''}`,
      absentOf:           (absent, total, rate) => `ขาด ${absent}/${total} คาบ (${rate}%)`,
      conductLeft:        (n) => `คะแนนเหลือ ${n}`,

      colLeaveType:       'ประเภท',
      colLeaveDates:      'วันที่ลา',
      colNote:            'หมายเหตุ',
      colReportedBy:      'ผู้แจ้ง',
    },

    attendance: {
      pageTitle:       'รายงานการเข้าเรียน (ภาคศาสนา)',
      mode_day:        'รายวัน',
      mode_week:       '7 วัน',
      mode_month:      'รายเดือน',
      prev:            'ก่อนหน้า',
      next:            'ถัดไป',
      today:           'วันนี้',

      present:         'มาเรียน',
      absent:          'ขาด',
      late:            'สาย',
      leave:           'ลา',

      coverage:        'เช็คชื่อแล้ว',
      slots:           'คาบ',
      ofAll:           (pct) => `คิดเป็น ${pct}% ของที่เช็คชื่อ`,

      uncheckedTitle:  'คาบที่ยังไม่ได้เช็คชื่อ',
      slotCount:       (n) => `${n} คาบ`,
      allChecked:      'เช็คชื่อครบทุกคาบในช่วงนี้',
      excusedNote:     (n) => `(ไม่นับ ${n} คาบที่ปฏิทินระบุว่างดสอน)`,
      noTeacher:       'ยังไม่มีครูผู้สอน',

      byDateTitle:     'สัดส่วนรายวัน',
      byRoomTitle:     'รายห้อง',
      roomCount:       (n) => `${n} ห้อง`,
      showAllRooms:    (n) => `แสดงห้องที่ปกติด้วย (${n} ห้อง)`,
      noRoomIssue:     'ทุกห้องเช็คชื่อครบและไม่มีนักเรียนขาดในช่วงนี้',
      noRecord:        'ยังไม่มีการเช็คชื่อ',

      colDate:         'วันที่',
      colPeriod:       'คาบ',
      colRoom:         'ห้อง',
      colSubject:      'วิชา',
      colTeacher:      'ครูผู้สอน',
      colShare:        'สัดส่วน',
      colChecked:      'เช็คแล้ว',
      colAbsentRate:   '% ขาด',
      colStudent:      'นักเรียน',
      colOfChecked:    '% ที่ขาด',

      absentStudentsTitle: 'นักเรียนที่ขาดในช่วงนี้',
      noAbsentStudent: 'ไม่มีนักเรียนขาดในช่วงนี้',
      cappedNote:      '(แสดงมากสุด 100 คนแรก เรียงตามจำนวนครั้งที่ขาด)',
      clickStudentHint:'กดที่แถวเพื่อเปิดหน้าติดตามนักเรียนรายคน',

      noTeachingTitle: 'วันที่ปฏิทินระบุว่างดสอน',
      noTeachingNote:  'ใช้เฉพาะรายการที่หยุดทั้งโรงเรียน — รายการที่ระบุเฉพาะบางห้อง/บางระดับเป็นห้องของภาคสามัญ เทียบกับห้องภาคศาสนาไม่ได้',
    },

    absence: {
      pageTitle:        'ติดตามนักเรียนขาดเรียน (ภาคศาสนา)',
      filterStatus:     'สถานะที่ดู',
      // ป้ายการ์ดตัวเลขประกอบจากสถานะที่เลือก — เลือกขาดอย่างเดียวได้ 'คาบที่ขาด'
      // เหมือนเดิม เลือกหลายอันได้ 'คาบที่ขาด/สาย' ไม่ใช่ป้ายกลาง ๆ ที่ไม่บอกว่านับอะไร
      statPeriodsOf:    (s) => `คาบที่${s}`,
      statStudentsOf:   (s) => `นักเรียนที่${s}`,
      statWithLeave:    'ขาด/สายทั้งที่มีใบลา',
      withLeaveHint:    'ครูกาขาดหรือสายทั้งที่นักเรียนแจ้งลาไว้แล้ว — ควรกลับไปแก้การเช็คชื่อ',
      hasLeave:         (type) => `มีใบลา (${type})`,
      matchedLeave:     (type) => `ใบลา: ${type}`,
      // แถวที่ครูกาว่า "ลา" แต่ไม่มีใบลาครอบวันนั้นในระบบ — คำถาม "ใครแจ้งลา"
      // ตอบได้ว่าไม่มีใครแจ้ง ซึ่งต้องบอก ไม่ใช่ปล่อยช่องว่างให้เดาเอง
      noLeaveDoc:       'ไม่พบใบลาในระบบ',
      onlyWithLeave:    (n) => `ดูเฉพาะที่มีใบลา (${n})`,
      viewPeriod:       'รายคาบ',
      viewStudent:      'สรุปรายคน',
      colStatus:        'สถานะ',
      colRegularClass:  'ชั้นสามัญ',
      colDorm:          'หอพัก',
      colTotal:         'รวม',
      colDays:          'จำนวนวัน',
      colWithLeave:     'มีใบลา',
      empty:            'ไม่พบข้อมูลตามสถานะที่เลือกในช่วงนี้',
      footerHint:       'กดที่แถวเพื่อเปิดหน้าติดตามนักเรียนรายคน · สีแถว: แดง = ขาด · เหลือง = สาย · ฟ้า = ลา · ป้ายเหลืองท้ายชื่อคือถูกกาขาด/สายทั้งที่มีใบลา',
    },

    leave: {
      pageTitle:        'นักเรียนที่ลา (ภาคศาสนา)',
      type: {
        sick:     'ลาป่วย',
        personal: 'ลากิจ',
        home:     'กลับบ้าน',
      },
      // ฝ่ายที่แจ้ง — สี่ฝ่ายแจ้งลง tb_student_leave ตารางเดียวกัน และครูคนหนึ่ง
      // เป็นได้ทั้งครูประจำชั้นสามัญและครูประจำชั้นศาสนา ชื่ออย่างเดียวจึงไม่พอ
      //
      // ชุดเดียวใช้ทุกที่ที่บอก "ใครแจ้งลา" (รายการลา · ติดตามขาดเรียน · การเข้าเรียน
      // รายบุคคล) — เคยมีตัวย่อ 'สามัญ/ศาสนา/ปกครอง' ไว้ใช้ในตาราง แต่คำว่า "สามัญ"
      // ลอย ๆ ไม่ได้บอกว่าเป็นครูประจำชั้น และคนอ่านต้องเดาว่าย่อมาจากอะไร
      source: {
        advisor:         'ครูประจำชั้นสามัญ',
        islamic_advisor: 'ครูประจำชั้นศาสนา',
        discipline:      'ฝ่ายปกครอง',
        academic:        'หัวหน้าวิชาการ',
        home_leave:      'ใบกลับบ้าน (ฝ่ายปกครอง)',
      },
      filterType:       'ประเภท',
      allTypes:         'ทุกประเภท',
      filterSource:     'ฝ่ายที่แจ้ง',
      allSources:       'ทุกฝ่าย',
      search:           'ค้นหา',
      searchPlaceholder:'ชื่อ เลขประจำตัว หรือหมายเหตุ',
      statLeaves:       'ใบลา',
      statStudents:     'นักเรียน',
      statDays:         'วันลารวม',
      daysHint:         'นับเฉพาะวันที่อยู่ในช่วงที่เลือก',
      statByType:       'แยกตามประเภท',
      listTitle:        'รายการลา',
      leaveCount:       (n) => `${n} รายการ`,
      colType:          'ประเภท',
      colDates:         'ช่วงวันที่ลา',
      colDays:          'วัน',
      colNote:          'หมายเหตุ',
      colReportedBy:    'ผู้แจ้ง',
      openEnded:        'ยังไม่ระบุวันกลับ',
      returnedAt:       (at) => `กลับเข้าโรงเรียน ${at}`,
      empty:            'ไม่มีการลาในช่วงนี้',
      footerHint:       'รวมการลาทุกทางที่มีผลกับนักเรียน ทั้งที่ครูแจ้งลาและใบกลับบ้านที่ฝ่ายปกครองอนุมัติ · ช่องวันแสดง "วันที่อยู่ในช่วงที่เลือก / ความยาวทั้งใบ"',
    },

    // ---- การเข้าเรียนรายบุคคล ----
    // ป้ายคอลัมน์ที่ซ้ำกับหน้าอื่น (นักเรียน/ห้อง/สถานะการเข้าเรียน/ประเภทการลา) ใช้ของเดิม
    // จากหมวด attendance / leave / absence ไม่ประกาศซ้ำ — คำเดียวกันต้องแปลเหมือนกันทุกหน้า
    individual: {
      pageTitle:      'การเข้าเรียนรายบุคคล (ภาคศาสนา)',
      tabIndividual:  'รายบุคคล',
      tabRisk:        'กลุ่มเสี่ยง',
      search:         'ค้นหานักเรียน',
      searchPlaceholder: 'เลขประจำตัว หรือชื่อ-สกุล',
      searchBtn:      'ค้นหา',
      noResult:       'ไม่พบนักเรียนที่ค้นหา',
      resultCount:    (n) => `พบ ${n} คน`,
      resultCapped:   '(แสดงมากสุด 30 คนแรก — ถ้าไม่เจอให้ค้นให้เจาะจงกว่านี้)',
      pickStudent:    'ค้นหานักเรียน หรือกดจากแท็บกลุ่มเสี่ยง เพื่อดูการเข้าเรียนรายคาบ',
      from:           'ตั้งแต่วันที่',
      to:             'ถึงวันที่',
      wholeYear:      'ทั้งปี',
      rangeHint:      'ไม่ระบุช่วงวันที่ = ทั้งปีการศึกษา',
      needBothDates:  'ต้องระบุทั้งวันเริ่มต้นและวันสิ้นสุด',
      regularClass:   'ชั้นสามัญ',
      dorm:           'หอพัก',
      moved:          'ย้ายห้องแล้ว',
      trackingBtn:    'หน้าติดตามนักเรียน',
      statRate:       'เข้าเรียน',
      rateHint:       'นับ มาเรียน + สาย เป็นเข้าเรียน',
      hasLeave:       (type) => `มีใบลา (${type})`,
      bySubjectTitle: 'การเข้าเรียนรายวิชา',
      subjectCount:   (n) => `${n} วิชา`,
      colSubject:     'วิชา',
      colTeacher:     'ครูผู้สอน',
      colTotal:       'รวม',
      colRate:        'เข้าเรียน',
      detailTitle:    'รายการเข้าเรียน',
      recordCount:    (n) => `${n} ครั้ง`,
      colDate:        'วันที่',
      colPeriod:      'คาบ',
      colTopic:       'หัวข้อที่สอน',
      colStatus:      'สถานะ',
      noTopic:        'ไม่ระบุ',
      empty:          'ไม่มีข้อมูลการเข้าเรียนในช่วงที่เลือก',
      notFound:       'ไม่พบทะเบียนภาคศาสนาของนักเรียนคนนี้ในปีการศึกษาที่เลือก',
      excel:          'Excel',
      detailFooter:   'แถวสีเหลืองคือถูกกาขาดทั้งที่มีใบลาครอบอยู่ · การแก้การเช็คชื่อเป็นหน้าที่ของครูผู้สอน',
      minAbsent:      'ขาดอย่างน้อย (ครั้ง)',
      riskTitle:      'นักเรียนกลุ่มเสี่ยงขาดเรียน',
      riskEmpty:      'ไม่พบนักเรียนที่เข้าเกณฑ์',
      riskCapped:     '(แสดงมากสุด 500 คนแรก)',
      riskFooter:     'กดที่แถวเพื่อดูการเข้าเรียนรายคาบของคนนั้นในช่วงเดียวกัน · ไม่รวมนักเรียนที่จำหน่ายแล้ว',
    },

    studentList: {
      pageTitle:         'รายชื่อนักเรียนรายห้อง (ภาคศาสนา)',
      advisor:           'ครูประจำชั้น',
      colNo:             'เลขที่',
      colId:             'เลขประจำตัว',
      colName:           'ชื่อ-สกุล',
      colRegularClass:   'ชั้นสามัญ',
      colDorm:           'หอพัก',
      colStatus:         'สถานะ',
      colInfo:           'ข้อมูล',
      // คำเดียวกับที่ภาคสามัญใช้ (server/utils/statusUtil.js) — หัวหน้าวิชาการอ่านทั้งสองหน้า
      status: {
        active:    'กำลังศึกษาอยู่',
        withdrawn: 'จำหน่ายแล้ว',
        graduated: 'จบแล้ว',
        newcomer:  'นักเรียนใหม่',
      },
      viewBtn:           'ดูข้อมูล',
      viewBtnTip:        'ดูข้อมูลรายคน (อ่านอย่างเดียว)',
      viewTable:         'มุมมองตาราง',
      viewCard:          'มุมมองการ์ด',
      dormTip:           'ดูรายชื่อนักเรียนร่วมหอ',
      dormTitle:         (name) => `นักเรียนในหอ ${name}`,
      dormVillage:       (v) => `หมู่บ้าน${v}`,
      dormEmpty:         'ไม่พบนักเรียนในหอนี้',
      dormColClass:      'ชั้นเรียน',
      dormColIslamic:    'ชั้นศาสนา',
      loading:           'กำลังโหลด...',
      noStudents:        'ไม่พบนักเรียนในห้องนี้',
      newcomerCount:     (n) => `นักเรียนใหม่ ${n} คน`,
      leftCount:         (n) => `ออกแล้ว ${n} คน`,
      movedCount:        (n) => `ย้ายห้อง ${n} คน`,
      roomHeading:       (room) => `ชั้น ${room}`,
      selectRoom:        '-- เลือกห้องเรียน --',
      pickRoomFirst:     'เลือกห้องเรียนเพื่อดูรายชื่อนักเรียน',
      movedTo:           (room) => `ย้ายไป ${room}`,
      movedToUnknown:    'ย้ายออกแล้ว (ไม่พบห้องปลายทาง)',
      inRoomCount:       (n) => `อยู่ในห้อง ${n} คน`,
    },
  },
}
